import theme from './theme'

const colors = theme.colors
const fonts = theme.fonts

export {
  colors,
  fonts,
}
